import { z } from "zod";
import { LOCATION_TYPES } from "../enums.ts";

export const ProductInput = z.object({
  companyId: z.string().uuid(),
  name: z.string().min(1).max(300),
  brand: z.string().max(200).nullable().optional(),
  productCode: z.string().max(255).nullable().optional(),
  tradeName: z.string().max(200).nullable().optional(),
  designation: z.string().max(60).nullable().optional(),
  restriction: z.string().max(60).nullable().optional(),
  symbol: z.string().max(60).nullable().optional(),
  privateLabel: z.boolean().default(false),
  approvalStatus: z.string().max(60).default("pending"),
  passover: z.boolean().default(false),
  fish: z.boolean().default(false),
  pasYisroel: z.boolean().default(false),
  cholovYisroel: z.boolean().default(false),
  bishulYisroel: z.boolean().default(false),
  kitniyos: z.boolean().default(false),
  mevushal: z.boolean().default(false),
  yoshon: z.enum(["na", "yes", "no"]).default("na"),
  vegan: z.boolean().default(false),
  paleo: z.boolean().default(false),
  nonGmo: z.boolean().default(false),
  notes: z.string().max(4000).nullable().optional(),
  adminNotes: z.string().max(4000).nullable().optional(),
  upcs: z.array(z.object({ upc: z.string().max(40), description: z.string().max(120).nullable().optional() })).default([]),
  locations: z
    .array(
      z.object({
        locationType: z.enum(LOCATION_TYPES),
        locationId: z.string().uuid(),
        designationOverride: z.string().max(60).nullable().optional(),
      }),
    )
    .default([]),
});
export type ProductInput = z.infer<typeof ProductInput>;
export const ProductUpdateInput = ProductInput.partial().omit({ companyId: true });

export const FormulaLineInput = z.object({
  companyIngredientId: z.string().uuid(),
  lineNo: z.number().int().min(1),
  quantity: z.string().max(60).nullable().optional(),
  notes: z.string().max(400).nullable().optional(),
});
export const FormulaInput = z.object({ lines: z.array(FormulaLineInput) });

export const ProductQuery = z.object({
  q: z.string().max(200).optional(),
  companyId: z.string().uuid().optional(),
  approvalStatus: z.string().max(60).optional(),
  designation: z.string().max(60).optional(),
});
